import React from 'react';
import { Collapse, List } from 'antd-mobile';
import { OSS_PREFIX } from '../../oss.config';

const FAQ = () => {
  const faqs = [
    {
      title: '设备无法开机',
      content: <>
        <List mode="card">
          <List.Item>1. 检查电量是否充足，尝试充电后再开机</List.Item>
          <List.Item>2. 确保电源键正确按下（长按3秒以上）</List.Item>
        </List>
      </>
    },
    {
      title: '提示网络出现问题',
      content: <>
        <List mode="card">
          <List.Item>① 尝试将设备关机后重新启动</List.Item>
          <List.Item>② 若仍然有问题，请检查当前网络是否正常，可以用手机连接相同网络，进入视频网站，看使用是否流畅</List.Item>
          <List.Item>③ 尝试更换一个新的网络</List.Item>
        </List>
      </>
    },
    {
      title: '卡片不响应',
      content: <>
        <List mode="card">
          <List.Item>注意卡中心区和眼镜的卡片感应区重叠</List.Item>
        </List>
      </>
    },
    {
      title: '配网相关问题',
      content: <>
        <List mode="card">
          <List.Item className='wifi-card-tip'>1. 小程序提示无法查找到设备</List.Item>
          <List.Item>请确认设备处于配网模式，并靠近手机</List.Item>
          
          <List.Item className='wifi-card-tip'>2. 填写WiFi账号密码后，联网不成功</List.Item>
          <List.Item>请检查：</List.Item>
          <List.Item>设备是否处于配网状态</List.Item>
          <List.Item>手机的蓝牙和定位服务是否开启</List.Item>
          <List.Item>WiFi账号密码是否正确</List.Item>
          <List.Item>当前连接的WiFi是否是2.4G频段</List.Item>
          
          <List.Item>
            <p className='warning-tip'>
              ⚠️ 注意事项：<br/>
              ① WiFi仅支持2.4G频段，5G频段无法使用<br/>
              ② 若家里WiFi是5G频段，请把WiFi路由器设置为2.4G或双频合一模式<br/>
              ③ 若使用手机热点，注意设置为2.4G频段。华为设备在"个人热点"设置界面中，找到"更多共享设置"或"显示高级选项"，即可设置。IOS设备在"个人热点"设置界面中，找到 "最大兼容性" 选项，将其开关打开，即可设置为 2.4GHz 频段。其它设备可在系统搜索"热点"关键词进入相应的界面进行设置
            </p>
          </List.Item>
        </List>
      </>
    },
    {
      title: '音量无法调节',
      content: <>
        <List mode="card">
          <List.Item>尝试按下音量键时稍停片刻再松开</List.Item>
        </List>
      </>
    },
    {
      title: '摇一摇无法使用',
      content: <>
        <List mode="card">
          <List.Item>该功能仅在小可豆没有倾听和讲话时生效哦。设备开机准备过程中，或者其它异常状态（网络异常、没有插入角色小豆芽等）无法使用哦</List.Item>
        </List>
      </>
    },
    {
      title: '多设备使用问题',
      content: <>
        <List mode="card">
          <List.Item>一个孩子同时只能绑定一个设备。若你拥有多个设备（通常是多个孩子分别使用），注意绑定或配网时先选择正确的孩子，再进行操作。以避免孩子原来绑定的设备被自动解绑</List.Item>
          <List.Item>若某个孩子已经绑定了一个设备，再用其它设备进行绑定或配置网络，原设备会自动解绑为不可用（此时重新进行配网即可再次绑定）</List.Item>
        </List>
      </>
    }
  ];

  return (
    <Collapse accordion>
      {faqs.map((faq, index) => (
        <Collapse.Panel key={index.toString()} title={faq.title}>
          {faq.content}
        </Collapse.Panel>
      ))}
    </Collapse>
  );
};

export default FAQ;